module.exports = __webpack_public_path__ + "static/media/19ESCAP22.54611f2c.jpg";